import { render, staticRenderFns } from "./BreadcrumbList.vue?vue&type=template&id=7997316d&scoped=true&lang=pug"
import script from "./BreadcrumbList.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbList.vue?vue&type=script&lang=ts"
import style0 from "./BreadcrumbList.vue?vue&type=style&index=0&id=7997316d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7997316d",
  null
  
)

export default component.exports